import { useState, useCallback } from "react";

/**
 * useReportExport - Hook to manage asynchronous export loading state.
 * Yields execution to browser to allow the spinner/modal to paint before heavy PDF/Excel calculations run.
 */
export function useReportExport() {
  const [exportingText, setExportingText] = useState(null);

  const runExport = useCallback((label, exportFn) => {
    setExportingText(label);
    // Yield to the event loop so the UI updates and displays the loader
    setTimeout(() => {
      try {
        exportFn();
      } catch (err) {
        console.error("Export error:", err);
      } finally {
        setExportingText(null);
      }
    }, 60);
  }, []);

  return {
    exportingText,
    setExportingText,
    runExport,
  };
}

export default useReportExport;
